/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2021, Zumper
 * @description App banner for use in detail pages
 */

import { Close, Zumper } from '@zcode-ui/icons'
import { Button, cn } from '@zcode-ui/shadz-ui'
import { rootRelative } from '@zcode/utils'
import * as React from 'react'
import { Ratings } from '../Ratings/Ratings'
import { USE_THE_APP, ZUMPER } from '../constants'
import type { Props } from '../types'

interface BannerProps extends Props {
  isGallery?: boolean
}

export const DetailBanner = React.memo(function DetailBanner({
  handleClose,
  isHidden,
  url,
  isGallery,
}: BannerProps) {
  return (
    <div
      className={cn(
        'w-full flex items-center bg-blue-900 justify-between px-6 py-4 fixed z-sticky max-[320px]:px-4',
        isHidden && 'hidden',
        isGallery ? 'bottom-0' : 'top-0'
      )}
      style={{
        height: 'calc(1px * var(--header-height, 86))',
      }}
    >
      <div className="flex items-center text-gray-0 text-base font-bold justify-center leading-6">
        <Button
          aria-label="close"
          className="hover:bg-transparent"
          onClick={() => handleClose()}
          variant="ghost"
        >
          <Close fill="#FFFFFF" size={11} strokeWidth={1.5} />
        </Button>
        <div className="flex items-center bg-gray-0 rounded-lg size-10 justify-center mr-4">
          <Zumper />
        </div>
        <div className="flex flex-col">
          {ZUMPER}
          <Ratings fill="#FFFFFF" size={12} />
        </div>
      </div>
      <a
        className="bg-gray-0 border-none rounded-[120px] text-gray-950 text-sm font-bold h-10 px-6 py-2.5 -tracking-[0.2px] no-underline"
        href={rootRelative(url)}
      >
        {USE_THE_APP}
      </a>
    </div>
  )
})
